module.exports = require("compression");


/*****************
 ** WEBPACK FOOTER
 ** external "compression"
 ** module id = 12
 ** module chunks = 0
 **/